module.exports = {
  title: 'admin',
  is4: false
}
